<div class="chatbot-fab" (click)="toggleChat()" [class.hidden]="isOpen" *ngIf="isVisible">
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
  </svg>
</div>

<div class="chatbot-panel" [class.open]="isOpen" [class.expanded]="isExpanded" *ngIf="isVisible">
  <div class="chatbot-header">
    <div class="chatbot-header-info">
      <span class="chatbot-title">BECentral Copilot</span>
      <span class="chatbot-provider">{{ 'CHATBOT.PROVIDER_SUBTITLE' | translate }}</span>
    </div>
    <div class="chatbot-header-actions">
      <button class="chatbot-btn" (click)="toggleExpand()" [title]="isExpanded ? ('CHATBOT.COLLAPSE' | translate) : ('CHATBOT.EXPAND' | translate)">
        <svg *ngIf="!isExpanded" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="15 3 21 3 21 9"></polyline>
          <polyline points="9 21 3 21 3 15"></polyline>
          <line x1="21" y1="3" x2="14" y2="10"></line>
          <line x1="3" y1="21" x2="10" y2="14"></line>
        </svg>
        <svg *ngIf="isExpanded" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="4 14 10 14 10 20"></polyline>
          <polyline points="20 10 14 10 14 4"></polyline>
          <line x1="14" y1="10" x2="21" y2="3"></line>
          <line x1="3" y1="21" x2="10" y2="14"></line>
        </svg>
      </button>
      <button class="chatbot-btn" (click)="clearChat()" [title]="'CHATBOT.NEW_SESSION' | translate">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        </svg>
      </button>
      <button class="chatbot-btn" (click)="toggleChat()" [title]="'CHATBOT.CLOSE' | translate">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
  </div>

  <div class="chatbot-device-badge" *ngIf="currentDeviceMAC">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
      <line x1="8" y1="21" x2="16" y2="21"></line>
      <line x1="12" y1="17" x2="12" y2="21"></line>
    </svg>
    <span>{{ currentDeviceMAC }}</span>
    <span class="badge-status" [class.online]="isDeviceOnline" [class.offline]="!isDeviceOnline">{{ isDeviceOnline ? ('CHATBOT.BADGE_ONLINE' | translate) : ('CHATBOT.BADGE_OFFLINE' | translate) }}</span>
  </div>

  <div class="low-balance-banner" *ngIf="lowBalanceWarning">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
    <span>{{ lowBalanceWarning }}</span>
    <a routerLink="/pages/account/billing" class="low-balance-link" (click)="toggleChat()">{{ 'CHATBOT.ADD_CREDITS' | translate }}</a>
  </div>

  <div class="chatbot-messages" #messagesContainer>
    <div class="chatbot-welcome" *ngIf="messages.length === 0 && !pendingWorkflow">
      <div class="welcome-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M1 6v16l8-4 8 4V6a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4z"></path>
          <path d="M17 2h2a2 2 0 0 1 2 2v10"></path>
        </svg>
      </div>
      <p class="welcome-title">{{ 'CHATBOT.WELCOME_TITLE' | translate }}</p>
      <p class="welcome-text">{{ 'CHATBOT.WELCOME_TEXT' | translate }}</p>
      <p class="welcome-examples" [innerHTML]="'CHATBOT.WELCOME_SELECT_WORKFLOW' | translate"></p>
      <div class="workflow-buttons">
        <button class="workflow-btn health-btn" (click)="selectWorkflow('health')">
          <span class="workflow-icon">&#128225;</span>
          <span class="workflow-label">{{ 'CHATBOT.WORKFLOW_HEALTH' | translate }}</span>
        </button>
        <button class="workflow-btn connectivity-btn" (click)="selectWorkflow('connectivity')">
          <span class="workflow-icon">&#128268;</span>
          <span class="workflow-label">{{ 'CHATBOT.WORKFLOW_CONNECTIVITY' | translate }}</span>
        </button>
        <button class="workflow-btn alerts-btn" (click)="selectWorkflow('alerts')">
          <span class="workflow-icon">&#128276;</span>
          <span class="workflow-label">{{ 'CHATBOT.WORKFLOW_ALERTS' | translate }}</span>
        </button>
      </div>
    </div>

    <ng-container *ngFor="let msg of messages">
      <div *ngIf="msg.isStatusMessage" class="status-banner">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <span>{{ msg.content }}</span>
      </div>

      <div *ngIf="!msg.isDeviceCard && !msg.isStatusMessage && !msg.isBillingLimit && !msg.isAuthError" class="chatbot-message" [class.user]="msg.role === 'user'" [class.assistant]="msg.role === 'assistant'">
        <div class="message-bubble">{{ msg.content }}</div>
      </div>

      <div *ngIf="msg.isAuthError" class="auth-error-card">
        <div class="auth-error-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>
        <div class="auth-error-body">
          <div class="auth-error-title">{{ 'CHATBOT.AUTH_REQUIRED' | translate }}</div>
          <div class="auth-error-reason">{{ msg.content }}</div>
        </div>
      </div>

      <div *ngIf="msg.isBillingLimit" class="billing-limit-card">
        <div class="billing-limit-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
        </div>
        <div class="billing-limit-body">
          <div class="billing-limit-title">{{ 'CHATBOT.USAGE_LIMIT_REACHED' | translate }}</div>
          <div class="billing-limit-reason">{{ msg.content }}</div>
          <div class="billing-limit-hint" [innerHTML]="'CHATBOT.BILLING_HINT' | translate"></div>
        </div>
      </div>

      <div *ngIf="msg.isDeviceCard && msg.deviceSummary" class="device-card">
        <div class="device-card-header">
          <span class="device-model">{{ msg.deviceSummary.model }}</span>
          <span class="device-status" [class.online]="msg.deviceSummary.status === 'Online'" [class.offline]="msg.deviceSummary.status === 'Offline'">
            {{ msg.deviceSummary.status === 'Online' ? ('CHATBOT.BADGE_ONLINE' | translate) : ('CHATBOT.BADGE_OFFLINE' | translate) }}
          </span>
        </div>
        <div class="device-card-body">
          <div class="device-info-row">
            <span class="info-label">MAC</span>
            <span class="info-value">{{ msg.deviceSummary.mac }}</span>
          </div>
          <div class="device-info-row">
            <span class="info-label">IP</span>
            <span class="info-value">{{ msg.deviceSummary.ip }}</span>
          </div>
          <div class="device-info-row">
            <span class="info-label">FW</span>
            <span class="info-value">{{ msg.deviceSummary.firmware }}</span>
          </div>
          <div class="device-info-row">
            <span class="info-label">Network</span>
            <span class="info-value">{{ msg.deviceSummary.network }} / {{ msg.deviceSummary.band }}</span>
          </div>
          <div class="device-card-signals">
            <div class="signal-item">
              <span class="signal-label">RSRP</span>
              <span class="signal-value" *ngIf="msg.deviceSummary.rsrp !== null" [ngClass]="getSignalClass(msg.deviceSummary.rsrp, 'rsrp')">{{ msg.deviceSummary.rsrp }} dBm</span>
              <span class="signal-value signal-na" *ngIf="msg.deviceSummary.rsrp === null">N/A</span>
            </div>
            <div class="signal-item">
              <span class="signal-label">SINR</span>
              <span class="signal-value" *ngIf="msg.deviceSummary.sinr !== null" [ngClass]="getSignalClass(msg.deviceSummary.sinr, 'sinr')">{{ msg.deviceSummary.sinr }} dB</span>
              <span class="signal-value signal-na" *ngIf="msg.deviceSummary.sinr === null">N/A</span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <div class="progress-status" *ngIf="statusStep > 0">
      <div class="progress-step" [class.active]="statusStep >= 1" [class.done]="statusStep > 1">
        <span class="step-icon">&#128270;</span>
        <span class="step-text" *ngIf="statusStep === 1">{{ statusMessage }}</span>
        <span class="step-text" *ngIf="statusStep > 1">{{ 'CHATBOT.STEP_DEVICE_LOCATED' | translate }}</span>
      </div>
      <div class="progress-step" *ngIf="statusStep >= 2" [class.active]="statusStep >= 2" [class.done]="statusStep > 2">
        <span class="step-icon">&#128225;</span>
        <span class="step-text" *ngIf="statusStep === 2">{{ statusMessage }}</span>
        <span class="step-text" *ngIf="statusStep > 2">{{ 'CHATBOT.STEP_DATA_RETRIEVED' | translate }}</span>
      </div>
      <div class="progress-step" *ngIf="statusStep >= 3" [class.active]="statusStep >= 3">
        <span class="step-icon">&#129504;</span>
        <span class="step-text">{{ statusMessage }}</span>
      </div>
    </div>

    <div class="chatbot-typing" *ngIf="isLoading && statusStep === 0 && messages.length > 0 && messages[messages.length - 1]?.content === ''">
      <div class="typing-dots">
        <span></span><span></span><span></span>
      </div>
      <div class="loading-status-text" *ngIf="loadingStatusText">{{ loadingStatusText }}</div>
    </div>
  </div>

  <div class="chatbot-quick-actions" *ngIf="currentDeviceContext && !isLoading && !isFetchingDevice">
    <button class="quick-action-btn" (click)="sendQuickAction('What is the signal quality assessment?')">{{ 'CHATBOT.QUICK_SIGNAL' | translate }}</button>
    <button class="quick-action-btn" (click)="sendQuickAction('Are there any issues with this device?')">{{ 'CHATBOT.QUICK_ISSUES' | translate }}</button>
    <button class="quick-action-btn" (click)="sendQuickAction('What troubleshooting steps do you recommend?')">{{ 'CHATBOT.QUICK_TROUBLESHOOT' | translate }}</button>
    <button class="quick-action-btn syslog-btn" [class.disabled]="!isDeviceOnline" (click)="fetchAndAnalyzeSyslog()" [title]="isDeviceOnline ? ('CHATBOT.SYSLOG_TOOLTIP_ONLINE' | translate) : ('CHATBOT.SYSLOG_TOOLTIP_OFFLINE' | translate)">{{ 'CHATBOT.QUICK_SYSLOG' | translate }}</button>
    <button class="quick-action-btn alerts-btn" (click)="fetchDeviceAlerts(currentDeviceMAC)">{{ 'CHATBOT.QUICK_ALERTS' | translate }}</button>
    <button class="quick-action-btn ticket-btn" (click)="submitSupportTicket()">{{ 'CHATBOT.QUICK_TICKET' | translate }}</button>
  </div>

  <div class="chatbot-input-area">
    <textarea
      #messageInput
      [(ngModel)]="inputText"
      (keydown)="onKeyDown($event)"
      [placeholder]="pendingWorkflow ? ('CHATBOT.PLACEHOLDER_WORKFLOW' | translate) : (currentDeviceContext ? ('CHATBOT.PLACEHOLDER_DEVICE' | translate) : ('CHATBOT.PLACEHOLDER_DEFAULT' | translate))"
      rows="1"
      [disabled]="isLoading || isFetchingDevice"
    ></textarea>
    <button *ngIf="isLoading" class="chatbot-stop" (click)="stopGeneration()" title="Stop generating">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <rect x="6" y="6" width="12" height="12" rx="2"></rect>
      </svg>
    </button>
    <button *ngIf="!isLoading" class="chatbot-send" (click)="sendMessage()" [disabled]="!inputText.trim() || isLoading || isFetchingDevice">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="22" y1="2" x2="11" y2="13"></line>
        <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
      </svg>
    </button>
  </div>
</div>
